import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function AutorizationIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="24" height="24" />
			<circle opacity="0.5" cx="12.4998" cy="7.06522" r="4.06522" fill="white" />
			<path d="M12.5 13.3478C8.1699 13.3478 5.92818 16.2534 4.85828 18.4211C4.29426 19.5638 5.20288 20.7391 6.47722 20.7391H18.5228C19.7971 20.7391 20.7057 19.5638 20.1417 18.4211C19.0718 16.2534 16.8301 13.3478 12.5 13.3478Z" fill="white" />
		</svg>

	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AutorizationIcon fill={'#FFF'} />
		</div>
	);
}